<template>
  <div>
    <div class="pileDetail">
      <div>
        <el-image :src="image" />
      </div>
      <div class="details">
        <div class="specifier">
          <h1>储能 【用户侧微电网储能直流系统】</h1>
          <h3>产品特征 Product Features</h3>
          <ul>
            <li>三级BMS系统架构，安全可靠，充电具恒流充电、均充、浮充模式</li>
            <li>一体化预装式设计、定制化开发、安装方便；多种成熟集装箱内部布局方案可供选择，并结合具体需求进行局部定制化，一体设计，多重选择</li>
            <li>采用电气集成设计，集成直流变流与能量管理、电池管理系统、PCS、温控系统、消防系统、门禁系统、数据监控系统，交直流配电，照明系统等，系统效率高，成本低</li>
            <li>高防护等级设计，适应户外严酷环境，七氟丙烷自动灭火系统，符合消防安全规范</li>
            <li>满足只能电网设计规范，接受电网调度</li>
          </ul>
        </div>
        <div class="application">
          <span>减少用电成本</span>
          <span>实现系统备电</span>
          <span>降低用户侧增容费用</span>
          <span>提升系统可靠性</span>
        </div>
      </div>
    </div>
    <el-divider></el-divider>
    <div class="table">
<!--      <el-table-->
<!--        :stripe=true-->
<!--        highlight-current-row-->
<!--        :span-method="objectSpanMethod"-->
<!--        :data="tableData"-->
<!--        style="width: 95%">-->
<!--        <el-table-column-->
<!--          prop="type"-->
<!--          label="产品分类"-->
<!--          width="360px">-->
<!--        </el-table-column>-->
<!--        <el-table-column-->
<!--          prop="c30"-->
<!--          label="20尺集装箱"-->
<!--          width="360px">-->
<!--        </el-table-column>-->
<!--        <el-table-column-->
<!--          prop="c60"-->
<!--          width="360px"-->
<!--          label="40尺集装箱">-->
<!--        </el-table-column>-->
<!--      </el-table>-->
    </div>
  </div>
</template>

<script>
export default {
  name: "SYSTEM",
  data(){
    return{
      image:require('../../../assets/images/production/barrier/储能系统.png'),
      tableData: [
        {
          type: '功率',
          c30: '250~1000kw',
          c60: '500~2000kw',
        },
        {
          type: '容量',
          c30: '储能电池容量根据需求定制',
          c60: '储能电池容量根据需求定制',
        },
        {
          type: '防护等级',
          c30: 'IP54',
          c60: 'IP54',
        },
        {
          type: '工作温度',
          c30: '-30~55℃',
          c60: '-30~55℃',
        },
        {
          type: '工作海拔',
          c30: '3000m',
          c60: '3000m',
        },
        {
          type: '尺寸',
          c30: '5898*2352*2393',
          c60: '12032*2352*2393',
        },
        {
          type: '散热系统',
          c30: '工业空调/强制风冷',
          c60: '工业空调/强制风冷',
        },
        {
          type: '消防系统',
          c30: '气体消防(七氟丙烷)',
          c60: '气体消防(七氟丙烷)',
        },
        {
          type: '耐火测试',
          c30: '2小时',
          c60:'2小时'
        },
        {
          type: '风荷数',
          c30: '0.6kN/m³',
          c60: '0.6kN/m³',
        },
        {
          type: '抗震等级',
          c30: '10级',
          c60: '10级',
        },
        {
          type: '允许湿度范围',
          c30: '0~95(无凝霜)',
          c60: '0~95(无凝霜)',
        },
        {
          type: '满载海拔高度',
          c30: '5000m(＞4000m需降频)',
          c60: '5000m(＞4000m需降频)',
        },
        {
          type: '冷却方式',
          c30: '温控强制冷风',
          c60: '温控强制冷风',
        },
        {
          type: '通讯接口',
          c30: 'RS485/CAN/Ethernet',
          c60: 'RS485/CAN/Ethernet',
        }
      ]
    }
  },
  methods:{
    objectSpanMethod({row,column,rowIndex,columnIndex}){
      // if (columnIndex===0){
      //   return {
      //     rowspan:row.rowspan,
      //     colspan:1
      //   }
      // }
    },

  }
}
</script>

<style lang="less" scoped>
.pileDetail{
  margin: 30px 50px;
  overflow: hidden;
  img{
    float: left;
    height: 523.8px;
    width: 379.8px;
    padding: 20px 20px;
  }
  .details{
    float: left;
    margin: 20px 0;
    .specifier{
      width: 85%;
      ul{
        width: 80%;
        li{
          list-style: none;
          &:before{
            content: '';
            display: inline-block;
            width: 10px;
            height: 10px;
            background-color: #2c6bb6;
            border-radius: 50%;
            margin-right: 5px;
          }
        }
      }
    }
    .application{
      float: left;
      width: 85%;
      span{
        padding-left: 5px;
      }
    }
  }
  h1{
    padding: 0 5px;
    color: #2c6cb6;
  }
  h3{
    padding: 0 5px;
    color: #2c6cb6;
  }
}
.table{
  margin: 30px 50px;
}
</style>

